import { createSlice } from "@reduxjs/toolkit";
import { nanoid } from "@reduxjs/toolkit";

const reStructureInputFields = (arr, labelStatus) => {
  return arr.map((a) => {
    const id = nanoid();
    return {
      id,
      label: a,
      name: a,
      value: a,
      status: labelStatus?.[a]?.status || null,
    };
  });
};

const initialState = {
  mappingFields: [],
  requiredFields: [],
  optionalFields: [],
  disabledFooterSuccessBtn: false,
  showExlcudeVariantsPreview: false,
};

export const feedMappingSlice = createSlice({
  name: "feedMapping",
  initialState,
  reducers: {
    resetFeedMapping: () => initialState,
    setMappingFields: (state, action) => {
      const { requiredFields, optionalFields, labelStatus } = action.payload;
      state.requiredFields = reStructureInputFields(
        requiredFields,
        labelStatus
      );
      state.optionalFields = reStructureInputFields(
        optionalFields,
        labelStatus
      );
    },
    setMappingFieldsForCatalog: (state, action) => {
      state.mappingFields = reStructureInputFields(
        action.payload.fields,
        action.payload.labelStatus
      );
    },
    toggleExcludeVariantsPreview: (state, action) => {
      state.showExlcudeVariantsPreview = action.payload;
    },
    changeDisabledFooterSuccessBtn: (state, action) => {
      state.disabledFooterSuccessBtn = action.payload;
    },
  },
});

export const {
  resetFeedMapping,
  setMappingFields,
  setMappingFieldsForCatalog,
  toggleExcludeVariantsPreview,
  changeDisabledFooterSuccessBtn,
} = feedMappingSlice.actions;

export default feedMappingSlice.reducer;

export const selectMappingFields = (state) => state.feedMapping.mappingFields;
export const selectRequiredFields = (state) => state.feedMapping.requiredFields;
export const selectOptionalFields = (state) => state.feedMapping.optionalFields;
export const selectShowExcludeVariantsPreview = (state) =>
  state.feedMapping.showExlcudeVariantsPreview;
export const selectDisabledFooterSuccessBtn = (state) =>
  state.feedMapping.disabledFooterSuccessBtn;
